import React from "react";
import SellerBenefits from "./seller/SellerBenefits";
import BuyerBenefits from "./buyer/BuyerBenefits";

const BenefitsSection = () => {
  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto">
          <SellerBenefits />
          <BuyerBenefits />
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
